namespace TabAurous.HR {
    export interface PayrollPeriodForm {
        PayrollPeriodCode: Serenity.StringEditor;
        FromDate: Serenity.DateEditor;
        ToDate: Serenity.DateEditor;
    }

    export class PayrollPeriodForm extends Serenity.PrefixedContext {
        static formKey = 'HR.PayrollPeriod';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PayrollPeriodForm.init)  {
                PayrollPeriodForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;

                Q.initFormType(PayrollPeriodForm, [
                    'PayrollPeriodCode', w0,
                    'FromDate', w1,
                    'ToDate', w1
                ]);
            }
        }
    }
}
